<template>
  <div class="fullPage">
    <page :title="title" :breadcrumb="breadcrumb" :load="doInit">
      <v-card>
        <form data-vv-scope="cardListForm">
          <v-card-title>
            <div>
              <div class="headline">Credit Card List</div>
            </div>
            <v-spacer></v-spacer>
            <div slot="action">
              <v-tooltip top>
                <v-btn slot="activator" icon @click="doReview">
                  <v-icon color="primary">mdi-pencil</v-icon>
                </v-btn>
                <span>Review Credit Card List</span>
              </v-tooltip>
            </div>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-title>
            <div class="body-2">{{labels.creditCardList}}</div>
          </v-card-title>
          <v-card-text>
            <message :messages="messages" v-if="!cardNoDialog"></message>
            <v-container fluid grid-list-lg>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs6 v-if="newCreditCardList">
                    <v-text-field :label="labels.cardListCode" v-model="cardListForm.cardListCode" :error-messages="errors.collect('cardListCode')" v-validate="'required|param|max:20'" data-vv-name="cardListCode" :data-vv-as="labels.cardListCode"></v-text-field>
                  </v-flex>
                  <v-flex xs6 v-else>
                    <v-subheader class="queryLabel">{{labels.cardListCode}}</v-subheader>
                    <div class="subheading">{{cardListForm.cardListCode}}</div>
                  </v-flex>
                  <v-flex xs6>
                    <v-subheader class="queryLabel">{{labels.cardListDesc}}</v-subheader>
                    <div class="subheading">{{cardListForm.cardListDesc}}</div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
        </form>
        <v-divider></v-divider>
        <v-card-title>
          <div>
            <div class="headline">{{labels.cardNoList}}</div>
          </div>
          <v-spacer></v-spacer>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card-title>
        <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="cardNo" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ props.item.cardNo }}</td>
            <td class="text-xs-left">{{ props.item.cardDesc }}</td>
          </template>
        </v-data-table>
      </v-card>
    </page>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import * as TableConst from '@/mixins/table'

export default {
  data() {
    return {
      breadcrumb: [],
      headers: [
        { text: 'Card Number', value: 'cardNo' },
        { text: 'Card Description', value: 'cardDesc' }
      ],
      labels: {
        creditCardList: 'Credit Card List Details',
        cardNoList: 'Card Number List',
        cardListCode: 'Card List Code',
        cardListDesc: 'Card List Description',
        cardInfo: 'Card Information'
      },
      cardListForm: {
        cardListCode: undefined,
        cardListDesc: undefined,
        cardNoList: []
      },
      menu: [],
      items: []
    }
  },
  computed: {
    ...mapGetters([
      'derieveBreadcrumbByName'
    ]),
    title() {
      return 'Query Credit Card List'
    }
  },
  methods: {
    async doInit() {
      if (!this.newCreditCardList) {
        // Review
        await this.reviewCardList()
      }
    },
    async reviewCardList() {
      const apiURI = this.$store.state.promotionManagement.menu.creditCardListGet
      if (apiURI) {
        try {
          const expand = {
            cardListCode: this.cardListCode
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // Promotion init
            this.cardListForm.cardListCode = data.crCdList.cardListCode
            this.cardListForm.cardListDesc = data.crCdList.cardListDesc
            this.items = data.crCdList.cardNoList
            // Extract menu
            this.menu = extractMenu(result.data._links)
          }
        } catch (error) {
          throw error
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doReview() {
      this.$router.push({ name: 'creditCardListReview', params: { cardListCode: this.cardListCode } })
    }
  },
  mounted() {
    this.breadcrumb = this.derieveBreadcrumbByName('creditCardLists')
    this.breadcrumb.push({
      name: 'creditCardListQuery',
      text: this.title
    })
  },
  created() {
    this.doInit()
  },
  props: {
    cardListCode: {
      type: String,
      default: ''
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
